import { action, props } from 'ts-action';
import { RulerInteraction } from '../types/analytics-state.types';

export const setRulerInteraction = action(
  '[Analytics] setRulerInteraction',
  props<{ interaction: RulerInteraction }>(),
);

export const setEcgTimeStarted = action(
  '[Analytics] setEcgTimeStarted',
  props<{ timestamp: number }>(),
);

export const setRulerTimeStarted = action(
  '[Analytics] setRulerTimeStarted',
  props<{ timestamp: number }>(),
);
